import React from 'react';

import { Link as ChakraLink, Checkbox, CheckboxProps } from '@chakra-ui/react';
import { Link } from 'gatsby';
import { GlobalError, InternalFieldName, UseFormRegisterReturn } from 'react-hook-form';

import { Url } from '../../../misc/enums';

type FormCheckboxPrivacyProps<TFieldName extends InternalFieldName = InternalFieldName> =
	CheckboxProps & {
		error: GlobalError | undefined;
	} & Omit<UseFormRegisterReturn<TFieldName>, 'ref'>;

export const FormCheckboxPrivacy = React.forwardRef<HTMLInputElement, FormCheckboxPrivacyProps>(
	(props, ref) => {
		const { error, className, ...checkboxProps } = props;
		return (
			<div className={props.className}>
				<Checkbox
					isInvalid={!!error}
					colorScheme="primary"
					{...checkboxProps}
					ref={ref}
					aria-invalid={error ? true : undefined}
					aria-describedby={`${props.name}-error`}
					className="text-secondary-700"
				>
					Ich habe die{' '}
					<ChakraLink as={Link} to={`/${Url.DATA_PRIVACY}/`} className="underline">
						Datenschutzerklärung
					</ChakraLink>{' '}
					gelesen und akzeptiert.
				</Checkbox>

				{!!error && (
					<p className="mt-1 text-sm text-red-500" id={`${props.name}-error`}>
						{error.message}
					</p>
				)}
			</div>
		);
	},
);
